
$(document).scroll(function () {
    if (!$('.eight').length) {
        return
    }
    var topScroll = jQuery(window).scrollTop();
    let inner = window.innerHeight;
    if ($('.one').offset().top - topScroll <= inner) {
        $('.one').addClass('animated fadeInUp')
    }
    if ($('.two').offset().top - topScroll <= inner) {
        $('.two').addClass('animated fadeInUp')
    }
    if ($('.three').offset().top - topScroll <= inner) {
        $('.three').addClass('animated fadeInUp')
    }
    if ($('.four').offset().top - topScroll <= inner) {
        $('.four').addClass('animated fadeInUp')
    }
    if ($('.five').offset().top - topScroll <= inner) {
        $('.five').addClass('animated fadeInUp')
    }
    if ($('.six').offset().top - topScroll <= inner) {
        $('.six').addClass('animated fadeInUp')
    }
    if ($('.seven').offset().top - topScroll <= inner) {
        $('.seven').addClass('animated fadeInUp')
    }
    if ($('.eight').offset().top - topScroll <= inner) {
        $('.eight').addClass('animated fadeInUp')
    }
})


//////////////////
// WEBPACK FOOTER
// ./utils/contect.js
// module id = cjmV
// module chunks = 1